import { FC } from "react";

const CreateCustomRule: FC = () => {
  return (
    null
  )
}

export default CreateCustomRule;
